/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems3
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Creación – Se defienen los botones de la barra de navegación.
13/10/2021 Cristian Andres Pizo Mina -  Se agrego /Overtime
================================================================================ */

export const MenuItems2 = [
    { label: 'Nómina abierta', url: '/OpenPayroll', index: 0 },
    { label: 'Nómina acumulados históricos', url: '/HistoricPayroll', index: 1 },
    { label: 'Seguridad social', url: '/HistoricSocialSecurity', index: 2 },
    { label: 'Contabilidad', url: '/HistoricAccounting', index: 3 },
    { label: 'Nómina electrónica', url: '/HistoricElectronicPayroll', index: 4 }

];